import React from "react"

// https://www.youtube.com/howyoutubeworks/resources/brand-resources/#logos-icons-and-colors
import ytIcon from "@/components/YoutubeIcon/yt_icon_rgb.png"

export const YoutubeIcon = () => {
    return <img src={ytIcon} height="20" alt="Youtube Logo Icon" />
}
